class LightSwitch {
  constructor() {
    this.toggle = document.querySelector('.light-switch-checkbox');
    this.collectionHandle = document.querySelector('.products-toolbar__light-switch')?.dataset.collectionHandle;
    
    if (!this.toggle || !this.collectionHandle) return;
    
    this.storageKey = `light-switch-${this.collectionHandle}`;
    this.init();
  }
  
  init() {
    // Restore saved state
    const savedState = localStorage.getItem(this.storageKey) === 'true';
    if (savedState) {
      this.toggle.checked = true;
      document.body.classList.add('lights-on');
    }
    
    // Handle toggle
    this.toggle.addEventListener('change', () => {
      if (this.toggle.checked) {
        document.body.classList.add('lights-on');
        localStorage.setItem(this.storageKey, 'true');
      } else {
        document.body.classList.remove('lights-on');
        localStorage.setItem(this.storageKey, 'false');
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new LightSwitch());
} else {
  new LightSwitch();
}
